import { useState, type ReactNode } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface Props {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

/** Expand/collapse with aria-expanded (PSD §8.2 / TODO Task 1.17). */
export function Collapsible({ title, children, defaultOpen = false }: Props): JSX.Element {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="collapsible">
      <button
        className="collapsible-trigger"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="collapsible-chevron" aria-hidden="true">
          {open ? <ChevronDown size={14} strokeWidth={2} /> : <ChevronRight size={14} strokeWidth={2} />}
        </span>
        {title}
      </button>
      {open && <div className="collapsible-content">{children}</div>}
    </div>
  );
}
